import React from 'lib/react';
import {
  EVGrid, EVTypography,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useSelector } from 'lib/redux';
import HelpTooltip from 'commonComponents/helpTooltip/HelpTooltip.component';
import MeasurementInstructionsHelperComponent from 'commonComponents/measurementInstructionHelper/MeasurementInstructionsHelper.component';
import OrderStyles from '../OrderStyles';

function MeasurementInstructions() {
  const classes = OrderStyles();
  const {
    selectedMeasurementRequest, measurementRequestType, isAdmin,
  } = useSelector(({ userData, order }) => ({
    isAdmin: userData.orderPreferences?.isAdmin,
    measurementRequestType: userData.orderPreferences?.measurementRequestType,
    selectedMeasurementRequest: order.selectedMeasurementRequest,
  }));

  const { t } = useTranslation();

  return (
    <EVGrid className={classes.measurementInstructionsContainer}>
      <EVTypography>{t('order_measurementinstructions')}</EVTypography>
      <EVGrid container alignItems="center" wrap="nowrap" style={{ columnGap: '26px' }}>
        <MeasurementInstructionsHelperComponent disabled={!(isAdmin || measurementRequestType?.canEdit)} />
        <HelpTooltip title={t(`order_measurementrequest_helptext_${selectedMeasurementRequest}`)} />
      </EVGrid>
    </EVGrid>
  );
}

export default MeasurementInstructions;
